<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
    if (!this.$cookie.get("websiteLanguage")) {
      this.$cookie.set("websiteLanguage", "en");
      document.body.classList.add("LtrTheme")
    }else if(this.$cookie.get("websiteLanguage")=='ar'){
      document.body.classList.add("RtlTheme")
    }else{
      document.body.classList.add("LtrTheme")

    }
    this.$axios.defaults.headers.common["Accept-Language"] =
      this.$cookie.get("websiteLanguage");
  },
};
</script>
